import React from 'react';
import {
  DashboardRounded, PointOfSaleRounded, StorefrontRounded, ScheduleRounded,
  RestaurantRounded, KeyboardReturnRounded, ReceiptLongRounded, HistoryRounded,
  Inventory2Rounded, InventoryRounded, ShoppingCartRounded, SwapHorizRounded,
  UndoRounded, MoveToInboxRounded, PaymentsRounded, InsightsRounded, SavingsRounded,
  AccountBalanceWalletRounded, AdminPanelSettingsRounded, GroupsRounded, PaidRounded,
  TuneRounded, ReceiptRounded, AccountCircleRounded, SettingsRounded, CodeRounded,
  NotificationsActiveRounded
} from '@mui/icons-material';

// =====================================================================================
// Modern sidebar icon set. Under the "Full Modern" theme the classic TwoTone menu icons
// are swapped for solid Rounded ones so the navigation matches the Modern Dashboard's
// look. Keyed by the menu item's route (src/config/menu.tsx). Any path without an entry
// keeps its original icon, so new menu items degrade gracefully.
// =====================================================================================

const ICONS: Record<string, React.ReactElement> = {
  '/Dashboard': <DashboardRounded />,
  '/dashboard': <DashboardRounded />,
  '/sale/create': <PointOfSaleRounded />,
  '/terminal-3/full': <StorefrontRounded />,
  '/dashboard/work-shift': <ScheduleRounded />,
  '/dashboard/kitchen': <RestaurantRounded />,
  '/sale/return': <KeyboardReturnRounded />,
  '/sales/getAll': <ReceiptLongRounded />,
  '/sales/returnhistory': <HistoryRounded />,
  '/items/getAll': <Inventory2Rounded />,
  '/inventory/stock/items': <InventoryRounded />,
  '/inventory/purchase': <ShoppingCartRounded />,
  '/inventory/getall': <HistoryRounded />,
  '/inventory/stock/transfer': <SwapHorizRounded />,
  '/inventory/return': <UndoRounded />,
  '/inventory/goods-received': <MoveToInboxRounded />,
  '/expense': <PaymentsRounded />,
  '/reports': <InsightsRounded />,
  '/reports/cash-flow': <SavingsRounded />,
  '/finance/dashboard': <AccountBalanceWalletRounded />,
  '/management/setup/master/rolelist': <AdminPanelSettingsRounded />,
  '/user-management': <GroupsRounded />,
  '/salary-management': <PaidRounded />,
  '/management/setup/tabs': <TuneRounded />,
  '/management/billing': <ReceiptRounded />,
  '/management/profile/details': <AccountCircleRounded />,
  '/management/profile/settings': <SettingsRounded />,
  '/developer/dashboard': <CodeRounded />,
  '/developer/notifications': <NotificationsActiveRounded />
};

/** Modern icon for a menu path, or null to keep the item's own icon. */
export const modernMenuIcon = (path: string): React.ReactElement | null =>
  ICONS[path] ?? ICONS[(path || '').toLowerCase()] ?? null;
